<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong>Termo de Aceite</strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${ collapsed ? 'top' : 'bottom' }`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <modal />
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow class="ml-2">
                <validation-provider
                  v-slot="{ errors }"
                  name="Termo de aceite"
                  rules="required"
                  >
                    <input 
                      class="mr-2" 
                      type="checkbox" 
                      id="checkbox" 
                      value="false"
                      @change="onChange('form', $event)" 
                      v-model="form.termo_aceite"
                    >
                    <label for="checkbox">
                      Eu li e concordo com os
                      <CLink @click="showModal()">termos</CLink>
                      do checklist para criação de Loja Virtual
                    </label>
                    <br>
                    <span class="text-danger" v-if="errors">{{ errors[0] }}</span>
                </validation-provider>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import modal from './../templates/modal-termo.vue'
  export default {
    name: 'aceiteForm',
    components: { modal },
    props: {
      show: {
        type: Boolean,
        required: true
      },
      textTerm: {
        type: String,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.aceite
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.aceite 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'aceite')
        }
      }
    },
    methods: {
      ...mapActions(['saveTemoAceite', 'updateAccept']),
      save() {
        this.saveTemoAceite(this.form);
      },
      update() {
        this.updateAccept(this.form)
      },
      showModal() {
        const warningModal = false;
        this.$root.$emit('ShowModal::show', {
          warningModal: true,
        })
      },
      onChange(context, event) {
        if (context === 'store' && event === this.textTerm) {
          this.form.termo_aceite = true
        } else if (context === 'form' && event.target.checked === true) {
          this.form.termo_aceite = this.textTerm
        } else {
          this.form.termo_aceite = null
        }
      }
    }
  }
</script>
